module.exports = __webpack_public_path__ + "static/media/050.5c7e33ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/050.jpg
// module id = 395
// module chunks = 0